// extracted by mini-css-extract-plugin
module.exports = {"signup":"Signup_signup__3r_ti"};